// extracted by mini-css-extract-plugin
export var photoPopup = "styles-module__photoPopup___FE25G";
export var shimmer = "styles-module__shimmer___gJoJz";
export var shimmerWrapper = "styles-module__shimmerWrapper___dBnZY";